module.exports = require('./_global');


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-polyfill/~/core-js/modules/_path.js
 ** module id = 696
 ** module chunks = 1
 **/